import React, {
    Fragment,
} from 'react'
import Configurator from '../../../configurator'
import classnames from 'classnames'
import { i18n } from '../../../validator'

@i18n()
export default class ExploreTitle extends Configurator {
    render = () => {
        const { t } = this.props

        return (
            <div className={classnames({
                'Header-invite': true,
                'mt-40px': this.config.REACT_APP_SHOW_ACTUALITY === 'false',
                'd-none': this.isOstravaSystem(),
            })}>
                {(this.config.REACT_APP_SHOW_ACTUALITY === 'false') ?
                    <Fragment>
                        {t('exploreTitle', {
                            explore: (
                                <span className="Header-bolder">
                                    {t('explore')}
                                </span>
                            ),
                            own: (
                                <span className="Header-bold text-uppercase">
                                    {t('own')}
                                </span>
                            ),
                        })}
                    </Fragment>
                    :
                    <Fragment>&nbsp;</Fragment>
                }
            </div>
        )
    }
}
